import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Link } from 'react-router-dom'


const TextSection = ({data,withSpan}) => {
  return (
    <>
   <div className="wrapper">
            <div className={`textservice ${data.className}`} >
                <h3>
                    {withSpan ? (
                        <span>{data.heading}</span>
                    ) : (
                      data.heading
                    )}{" "}
                    {data.subheading}
                </h3>
                 {data.listItems ? (
                  <ul>
                    {data.listItems.map((item, index) => (
                      <li key={index}><FontAwesomeIcon icon={faCheckCircle} style={{ color: "rgb(255 102 204)" }}/>{item}</li>
                    ))}
                  </ul>
                ) : (
                  <p>{data.paragraph1}</p>
                )}
                <p>{data.paragraph2}</p>
                <Link to={data.url}>
              <button>{data.buttonText}</button></Link>
            </div>
        </div>
    </>
  )
}

export default TextSection